import { Component, Input, ViewChild } from '@angular/core';
import { ArquivoReferencia } from '../../../referencias';
import { ArquivoSearch } from '../../arquivo-search';
import { ArquivoFilter } from '../../filter';
import { ArquivoService } from '../../services';
import { ArquivoUploadModalComponent } from '../../upload/components/modal';
import { ArquivoTableComponent } from '../table';

@Component({
    selector: 'sgt-arquivo-card-view',
    templateUrl: 'arquivo-card-view.component.html',
    styleUrls: ['./arquivo-card-view.component.less']
})
export class ArquivoCardViewComponent {
    // Config
    @Input() title = 'Arquivos';
    @Input() headerText: string = null;
    @Input() idTable = 'tableArquivos';
    /** Se pode realizar edicões nos arquivos (Inserir novos, excluir, etc...) */
    @Input() canEdit = true;

    // Filter
    @Input() referencia: ArquivoReferencia;
    @Input() idReferenciaPai: number;
    @Input() idReferencia: number;
    /** Se deve exibir os multiselect dos filtros em dropup */
    @Input() dropupMultiselectsFilters = false;
    filter = new ArquivoFilter();

    @ViewChild('table') table: ArquivoTableComponent;
    @ViewChild('uploadModal') uploadModal: ArquivoUploadModalComponent;

    constructor(private arquivoService: ArquivoService) { }

    onFilterChange() {
        this.search();
    }

    onFilterCleaned() {
        this.search();
    }

    search() {
        this.table.search();
    }

    /** Ao excluir um arquivo */
    async onDelete(arquivo: ArquivoSearch) {
        try {
            arquivo = await this.arquivoService.delete(arquivo);
            this.table.toggleSelected(arquivo, false);
            this.table.refresh();
        } catch (error) {
            console.error(error);
        }
    }

    /** Abre o modal para realizar o upload */
    openUploadModal() {
        this.uploadModal.open(this.referencia, this.idReferenciaPai, this.idReferencia);
    }

    /** Após realizar o upload do arquivo */
    onAfterUpload(arquivos: ArquivoSearch[]) {
        if (!arquivos) {
            return;
        }
        this.table.refresh();
    }
}
